import React from 'react';
import classnames from 'classnames';

export default function CustomModal(props) {
  const { id, children, className, open, clickBackdrop = () => {} } = props;

  if (!open) return null;

  return (
    <div className={className} id={id}>
      <div
        className={classnames('Polaris-Modal-Dialog__Container')}
        data-polaris-layer="true"
        data-polaris-overlay="true">
        <div>
          <div role="dialog" aria-modal="true" tabIndex="-1" className="Polaris-Modal-Dialog">
            <div className="Polaris-Modal-Dialog__Modal">
              <div className="Polaris-Modal__BodyWrapper">
                <div className="Polaris-Modal__Body">{children}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="Polaris-Backdrop" onClick={clickBackdrop}></div>
    </div>
  );
}
